import React, { useState, useEffect, useCallback } from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "./SideNavbar.css";

const useStyles = makeStyles((theme) => ({
  navLink: {
    display: "block",
    marginBottom: theme.spacing(3),
    textDecoration: "none",
    color: theme.palette.text.secondary,
    transition: "all 0.3s ease",
    "&:hover": {
      color: theme.palette.secondary.main,
      transform: "translateX(-5px)",
    },
  },
  activeLink: {
    color: `${theme.palette.secondary.main} !important`,
    fontWeight: 600,
  },
}));

export const SideNavbar = () => {
  const classes = useStyles();
  const [activeNav, setActiveNav] = useState("#");
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = useCallback(() => {
    setIsVisible(window.scrollY > 100);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const navItems = [
    { id: "#home", label: "HOME" },
    { id: "#works", label: "PROJECTS" },
    { id: "#certificates", label: "CERTS" },
    { id: "#about", label: "ABOUT" },
    { id: "#contact", label: "CONTACT" },
  ];

  const handleClick = (id) => {
    setActiveNav(id);
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className={`side-navbar-container ${isVisible ? "visible" : ""}`}>
      <div className="side-navbar">
        {navItems.map((item) => (
          <a
            key={item.id}
            href={item.id}
            onClick={(e) => {
              e.preventDefault();
              handleClick(item.id);
            }}
            className={`${classes.navLink} ${
              activeNav === item.id ? classes.activeLink : ""
            }`}
            aria-label={`Navigate to ${item.label}`}
          >
            <Typography variant="subtitle2">{item.label}</Typography>
          </a>
        ))}
      </div>
    </div>
  );
};
